import { takeLatest, put } from 'redux-saga/effects';

import ListService from '../../../services/ListService';
import { apiCall } from '../../effects';
import {
  getListsRequest,
  getListsSuccess,
  getListsFail,
} from './actions';
import { logInSuccess } from '../auth/actions';
import { getErrorNotification } from '../../util';
import { notify } from '../notifications/actions';
import { getCurrentUserSuccess } from '../users/actions';

function* getLists() {
  try {
    const response = yield apiCall(ListService.get);
    yield put(getListsSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getListsFail());
  }
}

function* initLists() {
  try {
    yield put(getListsRequest());
  } catch (e) {
    console.log(e);
  }
}

export default [
  takeLatest(getListsRequest.type, getLists),
  // takeLatest(authInitSuccess.type, initLists),
  takeLatest(getCurrentUserSuccess.type, initLists),
  takeLatest(logInSuccess.type, initLists),
];
